import urlBuilder from "app/umbraco/helpers/urlBuilder";
import getUmbracoEndPoint from "app/umbraco/helpers/UmbracoEndPoint";

export default async (route: string, term: string): Promise<any> => {
    const url = urlBuilder("/api/search", { route: route, term: term, page: "0", take: "5" });

    const response = await fetch(url.toString(), {
        method: "GET",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Origin": getUmbracoEndPoint(),
            "X-Request-Domain": getUmbracoEndPoint()
        },
        body: undefined
    });

    if (response.status === 200) {
        return await response.json();
    }
    else {
        return new Promise<any>((resolve) => {
            return resolve({
                status: response.status
            });
        });
    }
};